export const forceCloseNavigator = () => {
    const menuDropdown = document.querySelector('.js-menu-navigator');
    if (menuDropdown) {
        menuDropdown.classList.add('hidden');
        document.body.classList.remove('menu-open');
    }
};
export const menuEvent = () => {
    const menuContainer = document.querySelector('.js-menu-container');
    if (menuContainer) {
        menuContainer.classList.toggle('open');
        if (menuContainer.classList.contains('open')) {
            forceCloseNavigator();
        }
        document.body.classList.toggle('menu-open');
    }
};
export const forceMenuClose = () => {
    const menuContainer = document.querySelector('.js-menu-container');
    if (menuContainer) {
        menuContainer.classList.remove('open');
        document.body.classList.remove('menu-open');
    }
};
export const mobileMenuInit = () => {
    const menuTrigger = document.querySelectorAll('.js-trigger-menu');
    const menuTriggerClose = document.querySelectorAll('.js-close-menu');
    menuTrigger.forEach((item) => {
        item.addEventListener('click', () => {
            menuEvent();
        });
    });
    menuTriggerClose.forEach((itemClose) => {
        itemClose.addEventListener('click', () => {
            forceMenuClose();
        });
    });
};
export const menuShowTriggerOnHover = (btnTrigger, menuDropdown) => {
    const eventOut = document.querySelector('.js-menu-mouseevent');
    btnTrigger.forEach((item) => {
        item.addEventListener('mouseover', () => {
            menuDropdown.classList.remove('hidden');
        });
    });
    if (eventOut) {
        eventOut.addEventListener('mouseout', (event) => {
            event.preventDefault();
            const target = event.target;
            if (!target.closest('.js-menu-navigator') && !target.closest('.js-navigator')) {
                event.preventDefault();
                console.log('target', target);
                console.log('Mouseout event occurred outside the .js-menu-navigator container');
                menuDropdown.classList.add('hidden');
            }
        });
    }
};
export const menuShowTrigger = (btnTrigger, menuDropdown) => {
    btnTrigger.forEach((item) => {
        item.addEventListener('click', (event) => {
            menuDropdown.classList.toggle('hidden');
            if (!menuDropdown.classList.contains('hidden')) {
                forceMenuClose();
                document.body.classList.add('menu-open');
            }
            else {
                document.body.classList.remove('menu-open');
            }
        });
    });
};
export const dropdownSubmenusToggle = () => {
    const btns = document.querySelectorAll('.js-menu-navigator-info-btn');
    if (btns) {
        btns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                const { target } = event;
                if (target instanceof HTMLElement) {
                    const container = target.closest('.js-menu-navigator-info');
                    if (container) {
                        container.classList.toggle('show');
                        const listItems = container.querySelectorAll('.js-menu-navigator-info-toggle');
                        if (listItems) {
                            listItems.forEach((item) => {
                                item.classList.toggle('hidden');
                            });
                        }
                    }
                }
            });
        });
    }
};
export const dropdownNavigatorInit = () => {
    const menuDropdown = document.querySelector('.js-menu-navigator');
    if (menuDropdown) {
        const btnTrigger = document.querySelectorAll('.js-navigator a');
        menuShowTrigger(btnTrigger, menuDropdown);
        if (window.innerWidth > 1200) {
            const btnTriggerForHover = document.querySelectorAll('.js-navigator');
            menuShowTriggerOnHover(btnTriggerForHover, menuDropdown);
        }
        const btnClose = document.querySelectorAll('.js-navigator-close');
        menuShowTrigger(btnClose, menuDropdown);
        dropdownSubmenusToggle();
    }
};
